export const labelColor = [
  "#fff",
  "#fff",
  "#f5e9b0",
  "#fff",
  "#db2a2a",
  "#fff",
];
